import { render } from "./tick.vue?vue&type=template&id=d4c52ca8"
import script from "./tick.vue?vue&type=script&lang=js"
export * from "./tick.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__